import { RawLocation, Route } from "vue-router";

export class RouteSerializer {
  public static saveRoute(route: Route): void {
    const obj: RawLocation = {
      name: route.name ?? undefined,
      path: route.path,
      params: route.params,
      query: route.query,
    };
    const serialized = JSON.stringify(obj);
    sessionStorage.setItem("nextRoute", serialized);
  }

  public static saveReactRoute(route: { search: string; pathname: string }): void {
    const queryParams = Object.fromEntries(new URLSearchParams(route.search));

    const obj: RawLocation = {
      name: "",
      path: route.pathname,
      params: {},
      query: queryParams,
    };
    const serialized = JSON.stringify(obj);
    sessionStorage.setItem("nextRoute", serialized);
  }

  public static loadSavedRoute(): RawLocation | undefined {
    const serialized = sessionStorage.getItem("nextRoute");
    if (serialized) {
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      return <RawLocation>JSON.parse(serialized);
    }
    return undefined;
  }
}
